import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import {
  FormGroup,
  Button,
  Intent
} from "@blueprintjs/core";
import { observable } from "mobx";
import Toast from "helpers/toaster";
import FormDrawer from "components/FormDrawer";
import { FieldError } from "components/FormBits";

@inject("workReportStore", "quoteStore", "store")
@observer
class AddInvoiceNumberModal extends Component {
  @observable error = null;

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.error = null;
    }
  }

  focusField() {
    const input = document.getElementById("work-report-invoice-number");
    if (input) {
      input.focus();
      input.select();
    }
  }

  createInvoiceNumber() {
    let {
      workReportStore: {
        workReport: {
          object
        }
      }
    } = this.props;

    const value = object.attributes.invoice_number;
    if (value === '' || value === null || value === undefined || String(value).trim() === '') {
      this.error = "Enter the invoice number.";
      this.focusField();
      return;
    }
    this.error = null;
    this.props.workReportStore
      .createInvoiceNumber()
      .then(this.onSuccessfullyCreateInvoiceNumber.bind(this))
      .catch(this.onFailCreateInvoiceNumber.bind(this));
  }

  onSuccessfullyCreateInvoiceNumber(response) {
    Toast.show({ message: 'Invoice number saved.', intent: Intent.SUCCESS })
    this.props.onSuccess(response);
  }

  onFailCreateInvoiceNumber(error) {
    const data = error && error.response && error.response.data;
    const reason = data && (data.errors || data.error);
    Toast.show({ message: reason ? [].concat(reason).join(' ') : "Couldn't save the invoice number. Try again.", intent: Intent.DANGER })
  }

  handleCloseInvoiceNumberDailog() {
    this.error = null;
    this.props.onClose();
  }

  render() {
    let {
      workReportStore: {
        workReport: {
          object,
          isLoading
        }
      }
    } = this.props;
    const busy = Boolean(isLoading);
    const close = this.handleCloseInvoiceNumberDailog.bind(this);
    const save = this.createInvoiceNumber.bind(this);
    const current = object && object.attributes && object.attributes.invoice_number;
    return (
      <FormDrawer
        isOpen={this.props.isOpen}
        title="Invoice number"
        icon="numerical"
        onClose={close}
        onOpened={this.focusField.bind(this)}
        busy={busy}
        footer={
          <>
            <Button text="Cancel" onClick={close} disabled={busy} />
            <Button
              icon="floppy-disk"
              intent={Intent.PRIMARY}
              onClick={save}
              loading={busy}
              text="Save invoice number"
            />
          </>
        }
      >
        <FormGroup
          className={this.error ? "has-error" : undefined}
          label="Invoice number"
          labelFor="work-report-invoice-number"
          labelInfo={<span className="fb-required">*</span>}
          helperText={this.error ? undefined : "The number of the invoice this work order was billed on, e.g. from your accounting system."}
        >
          <input
            id="work-report-invoice-number"
            type="text"
            className="bp3-input bp3-fill"
            placeholder="e.g. INV-10482"
            autoComplete="off"
            aria-invalid={Boolean(this.error)}
            aria-describedby={this.error ? "work-report-invoice-number-error" : undefined}
            value={current === null || current === undefined ? '' : current}
            onChange={event => {
              object.attributes.invoice_number = event.target.value;
              if (this.error && event.target.value.trim() !== '') {
                this.error = null;
              }
            }}
            onKeyDown={event => {
              if (event.key === "Enter" && !busy) {
                event.preventDefault();
                save();
              }
            }}
          />
          <FieldError id="work-report-invoice-number-error">{this.error}</FieldError>
        </FormGroup>
      </FormDrawer>
    );
  }
}

export default AddInvoiceNumberModal;
